<template>
  <base-icon-round-button class="mb-2 bg-info"
                          title="Add"
                          v-on="$listeners">
    <base-material-design-icon icon="add"/>
  </base-icon-round-button>
</template>

<script>
  import BaseIconRoundButton from '@/components/base-components/base-icons/BaseIconRoundButton';
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseIconRoundButtonAdd',
    components: {
      BaseMaterialDesignIcon,
      BaseIconRoundButton,
    },
  };
</script>

<style scoped>

</style>
